// extracted by mini-css-extract-plugin
module.exports = {"button":"Auth_button__2-xSn","button_connect":"Auth_button_connect__1jbyO"};